import api from "../../system/api";
import {getStorage} from "../../system/storage";

// «تمرکز این هفته» and «کارهای من» on the home page (backend: src/home/personal-focus.ts in zofino-strapi;
// docs/tasks/31-personal-focus.md). A person's own focus: a milestone, a project or «کارهای من», for a range.
const data = (response) => response?.data?.data;
const config = (extra = {}) => ({headers: {workspace: getStorage("workspace")}, suppressGlobalErrorHandler: true, ...extra});
const base = (workspaceId) => `/workspaces/${encodeURIComponent(workspaceId)}`;

export const personalFocusApi = {
    // the home section: {focus, tasks: {focus, other}, counts}
    get: async (workspaceId) => data(await api.get(`${base(workspaceId)}/home/personal-focus`, config()))?.section,
    // what may be chosen for a range: {milestones, projects, myTasks}
    options: async (workspaceId, range) => data(await api.get(`${base(workspaceId)}/personal-focus/options`, config({params: {range}}))),
    // {scopeType: "milestone" | "project" | "my_tasks", targetId, rangeKind: "week" | "two_weeks" | "month"}
    save: async (workspaceId, focus) => data(await api.put(`${base(workspaceId)}/personal-focus`, {data: focus}, config())),
    clear: async (workspaceId) => data(await api.delete(`${base(workspaceId)}/personal-focus`, config())),
};
